let serverBaseUrl
let environment

if (window.location.hostname === '127.0.0.1') {
  window.location.href = 'http://localhost:8080'
}

switch (window.location.hostname) {
  case 'localhost':
    serverBaseUrl = 'http://localhost:3000'
    environment = 'development'
    break
  case 'beta.climatepositivedesign.com':
  case 'app.climatepositivedesign.com':
    serverBaseUrl = 'https://api.climatepositivedesign.com'
    environment = 'production'
    break
  default:
    serverBaseUrl = 'https://api-staging.climatepositivedesign.com'
    environment = 'staging'
}

if (process.env.VUE_APP_SERVER_BASE_URL) {
  serverBaseUrl = process.env.VUE_APP_SERVER_BASE_URL
}

if (process.env.VUE_APP_ENVIRONMENT) {
  environment = process.env.VUE_APP_ENVIRONMENT
}

export { serverBaseUrl, environment }
